import { useSelector } from "react-redux";
import { getAppUser, getUserIsVerified } from "../../app/appSelectors";
import PageKYC from "../PageKYC/PageKYC";
import { Alert } from "react-bootstrap";

function Dashboard(props) {
    const userIsVerified = useSelector(getUserIsVerified);
    const userParams = useSelector(getAppUser);

    if (!userIsVerified) {
        return <PageKYC/>
    }

    return <>
        {
            userParams.blocked && <Alert variant="danger" className={'m-2'}>Service has been suspended due to low balance</Alert>
        }
        <div style={{
            padding: '10px'
        }}>
            {props.children}
        </div>
    </>
}

export default Dashboard;
